"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _attrAccept = _interopRequireDefault(require("attr-accept"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Label = _interopRequireDefault(require("../Label"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _UploadItem = _interopRequireDefault(require("./UploadItem"));

var _fileUtils = _interopRequireDefault(require("../utils/fileUtils"));

var _Upload = _interopRequireDefault(require("./Upload.style"));

var _dec, _class;

let Upload = (_dec = (0, _reactJss.default)(_Upload.default), _dec(_class = class Upload extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.removeFile = this.removeFile.bind(this);
    this.handleDragEvent = this.handleDragEvent.bind(this);
  }

  static getDerivedStateFromProps(props) {
    const renderCustomBth = !!props.children;
    const allowMultiple = props.type === 'avatar' ? false : props.multiple;
    const files = props.value || [];
    return {
      allowMultiple,
      renderCustomBth,
      files
    };
  }

  handleDragEvent(e) {
    const {
      visibility
    } = this.props;
    if (visibility !== 'visible') return;
    e.preventDefault();
    e.stopPropagation();

    switch (e.type) {
      case 'dragenter':
        this.setState({
          dragActive: true,
          dragError: null
        });
        break;

      case 'dragleave':
        this.setState({
          dragActive: false,
          dragError: null
        });
        break;

      case 'drop':
        this.setState({
          dragActive: false
        });
        this.loadDroppedFiles(e.dataTransfer.files);
        break;

      default:
        break;
    }
  }

  mergeFiles(newFiles) {
    const {
      renderCustomBth,
      hasAvatar,
      files
    } = this.state;
    if (!renderCustomBth || hasAvatar) return newFiles;
    return files.concat(newFiles);
  }

  loadDroppedFiles(files) {
    const {
      accept,
      multiple,
      acceptErrorText,
      multipleErrorText
    } = this.props;
    const {
      files: loadedFiles
    } = this.state;
    let error;

    if (!multiple && files.length > 1 || loadedFiles.length) {
      error = multipleErrorText;
    } else if (accept) {
      Array.prototype.forEach.call(files, i => {
        if (!(0, _attrAccept.default)(i, accept)) {
          error = acceptErrorText;
        }
      });
    }

    if (error) {
      this.setState({
        dragError: error
      });
    } else {
      this.selectFiles(files);
    }
  }

  checkError(files, maxFileSize) {
    const bigFile = files.find(i => i.size > maxFileSize);
    return !!bigFile;
  }

  selectFiles(filesSource) {
    var _this = this;

    return (0, _asyncToGenerator2.default)(function* () {
      const {
        id,
        onChange,
        visibility,
        maxFileSize
      } = _this.props;
      if (visibility !== 'visible') return;
      const files = yield _fileUtils.default.makeFilesArr(filesSource);

      const nFiles = _this.mergeFiles(files);

      _this.setState({
        files: nFiles
      });

      const error = _this.checkError(nFiles, maxFileSize);

      onChange({
        id,
        value: nFiles,
        error
      });
      _this.input.value = '';
    })();
  }

  removeFile(fileId) {
    const {
      id,
      onChange,
      maxFileSize
    } = this.props;
    const files = this.state.files.slice();
    const fileIndex = files.findIndex(i => i.id === fileId);
    files.splice(fileIndex, 1);
    this.setState({
      files,
      dragError: null
    });
    const error = this.checkError(files, maxFileSize);
    onChange({
      id,
      value: files,
      error
    });
  }

  renderPreview(viewType) {
    const {
      classes,
      maxFileSize,
      maxFileSizeErrorText
    } = this.props;
    const {
      files
    } = this.state;
    const fListClasses = viewType === 'default' ? classes.filesList : (0, _clsx.default)(classes.portal, 'portal');
    return _react.default.createElement("div", {
      className: fListClasses
    }, files.map(item => _react.default.createElement(_UploadItem.default, (0, _extends2.default)({
      key: item.id,
      maxFileSize: maxFileSize,
      maxFileSizeErrorText: maxFileSizeErrorText,
      error: item.size > maxFileSize,
      viewType: viewType,
      onRemove: this.removeFile
    }, item))));
  }

  renderPortalPreview() {
    const {
      portal
    } = this.props;
    return _reactDom.default.createPortal(this.renderPreview('portal'), portal);
  }

  renderDefaultBtn() {
    const {
      classes,
      label,
      browseLinkLabel,
      accept,
      multiple,
      visibility,
      preview
    } = this.props;
    const {
      files
    } = this.state;
    return _react.default.createElement(_react.Fragment, null, _react.default.createElement("div", {
      className: classes.loadBtn
    }, _react.default.createElement(_Icon.default, {
      className: classes.iconUpload,
      type: "hide"
    }), _react.default.createElement(_Label.default, {
      value: label
    }), "\xA0", _react.default.createElement("div", {
      className: classes.browseLinkBox
    }, _react.default.createElement(_Label.default, {
      className: classes.browseLink,
      value: browseLinkLabel
    }), _react.default.createElement("input", {
      ref: el => this.input = el,
      type: "file",
      accept: accept,
      disabled: visibility !== 'visible',
      multiple: multiple,
      onChange: e => this.selectFiles(e.target.files)
    }))), files.length && preview ? this.renderPreview('default') : null);
  }

  renderCustomBtn() {
    const {
      children,
      classes,
      type,
      accept,
      error,
      preview,
      portal,
      visibility
    } = this.props;
    const {
      files,
      allowMultiple
    } = this.state;
    const file = files[0];
    const params = {};

    if (file) {
      params.src = file.value;
    }

    const Components = _react.default.Children.map(children, child => _react.default.cloneElement(child, params));

    return _react.default.createElement("div", {
      className: classes.customBox
    }, type === 'avatar' ? _react.default.createElement(_Icon.default, {
      className: classes.iconCamera,
      type: "camera",
      size: "large",
      error: error
    }) : null, _react.default.createElement("input", {
      ref: el => this.input = el,
      type: "file",
      disabled: visibility !== 'visible',
      accept: accept,
      multiple: allowMultiple,
      onChange: e => this.selectFiles(e.target.files)
    }), Components, portal && preview && files.length ? this.renderPortalPreview() : null);
  }

  render() {
    const {
      classes,
      className,
      id,
      visibility,
      error,
      helperText
    } = this.props;
    const {
      renderCustomBth,
      dragActive,
      dragError
    } = this.state;
    const clUpload = (0, _clsx.default)(className, classes.upload, {
      custom: renderCustomBth
    }, {
      error: !!error || !!dragError
    }, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    }, {
      active: dragActive
    });
    const typeRender = renderCustomBth ? this.renderCustomBtn() : this.renderDefaultBtn();
    return _react.default.createElement("div", {
      id: id,
      className: clUpload,
      onDragEnter: this.handleDragEvent,
      onDragLeave: this.handleDragEvent,
      onDragOver: this.handleDragEvent,
      onDrop: this.handleDragEvent
    }, typeRender, _react.default.createElement(_Label.default, {
      className: classes.helperText,
      value: helperText || dragError,
      fontSize: "small"
    }));
  }

}) || _class);
Upload.defaultProps = {
  visibility: 'visible',
  error: false,
  multiple: false,
  preview: false,
  children: null,
  maxFileSize: null,
  label: 'Drop files to attach, or',
  maxFileSizeErrorText: 'Exceeds the maximum upload size',
  acceptErrorText: 'File type is not allowed',
  multipleErrorText: 'Only one file allowed to upload',
  browseLinkLabel: 'browse',
  type: 'default',
  onChange: () => {}
};
var _default = Upload;
exports.default = _default;